// frontend/my-react-app/src/index.js
// Updated: 2026-03-13 — ClerkProvider domain prop for barkingmeds.com (fixes blank page after sign-in)
// Entry point — wraps app in ClerkProvider, StrictMode.
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';

// Get Clerk Publishable Key from environment variables
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
// Optional: use custom Clerk domain (e.g. barkingmeds.com) when set; leave unset for localhost
const clerkDomain = process.env.REACT_APP_CLERK_DOMAIN || undefined;

// Create root and render app wrapped in ClerkProvider
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey} domain={clerkDomain}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
